import { loadConsentState, saveAcknowledgedConsent, initConsentStorage } from '@/utils/consentStorage';
import ConsentSettingsModal from '@/components/consent/ConsentSettingsModal.vue';
import { modalController } from '@ionic/vue';

export { initConsentStorage };

let openingSettings = false;

export function hasConsentDecision() {
  return loadConsentState() !== null;
}

export async function acknowledgeConsent() {
  await saveAcknowledgedConsent();
}

export async function openConsentSettings() {
  if (openingSettings) return;
  openingSettings = true;
  try {
    const modal = await modalController.create({
      component: ConsentSettingsModal,
      cssClass: 'fullscreen-modal',
    });
    await modal.present();
    await modal.onDidDismiss();
  } finally {
    openingSettings = false;
  }
}
